/*
 * nadi-a11y.js — every link says where it goes.
 *
 * WHAT WAS WRONG. Audited on the homepage at 1440: 45 visible links with no
 * accessible name at all — no text, no aria-label, no title, no alt on an image
 * inside them. A screen reader announces each one as "link" and nothing else.
 * That is WCAG 2.0 AA 2.4.4 and 4.1.2, which Israeli accessibility regulation
 * adopts through תקן ישראלי 5568, and this store publishes an accessibility
 * statement and runs an accessibility widget — so the gap is not academic.
 *
 * They come from Kalles' own patterns, not from anything written here: the
 * invisible `t4s-full-width-link` that makes a whole card or banner clickable,
 * the header's icon-only links, and the brand logo strip.
 *
 * TWO REMEDIES, AND WHICH ONE APPLIES IS DECIDED BY THE PAGE, NOT BY GUESSWORK.
 *
 * 1. If the same card already holds a NAMED link to the same destination — a
 *    product card has both its title link and an invisible overlay over the
 *    whole tile — the overlay is taken out of the accessibility tree. The
 *    destination is already reachable by name; a second, nameless route to it
 *    is noise. 32 of the 45 are this case.
 *
 * 2. Otherwise the link is given a name taken from WHERE IT ACTUALLY GOES. For
 *    a collection that is its real title, read from #NadiBrands, the block
 *    snippets/nadi-brand-data.liquid already prints on every page for the card
 *    brand line — so the name is the store's own wording, not a guess. For the
 *    header's fixed destinations it is the obvious Hebrew label. Nothing is
 *    invented and no visible text changes.
 *
 * A link with an EMPTY href is a third case and gets the first remedy: it is
 * decoration that happens to be an <a>, and announcing it helps nobody.
 *
 * This runs everywhere, phone included — an unnamed link is unnamed at every
 * width, and it is the mobile visitor using a screen reader who meets the
 * drawer and the cards most.
 */
(function () {
  'use strict';

  /* The store's real collection titles, keyed by handle. Same block the brand
     line reads; see snippets/nadi-brand-data.liquid. */
  var TITLES = (function () {
    var map = {};
    try {
      var el = document.getElementById('NadiBrands');
      if (!el) return map;
      var rows = JSON.parse(el.textContent) || [];
      for (var i = 0; i < rows.length; i++) map[rows[i][1]] = rows[i][0];
    } catch (e) { /* no map: fall back to the handle */ }
    return map;
  })();

  var FIXED = {
    '/search': 'חיפוש',
    '/account': 'החשבון שלי',
    '/cart': 'עגלת הקניות',
    '/': 'לעמוד הבית'
  };

  function named(el) {
    if (!el) return false;
    if ((el.textContent || '').trim()) return true;
    if (el.getAttribute('aria-label') || el.getAttribute('title')) return true;
    var img = el.querySelector('img[alt]');
    if (img && (img.getAttribute('alt') || '').trim()) return true;
    var t = el.querySelector('svg title');
    return !!(t && (t.textContent || '').trim());
  }

  function hide(a) {
    a.setAttribute('aria-hidden', 'true');
    a.setAttribute('tabindex', '-1');
  }

  function nameFromHref(href) {
    if (!href) return '';
    var path = href;
    try { path = new URL(href, location.origin).pathname; } catch (e) { /* relative already */ }
    if (FIXED[path]) return FIXED[path];

    var m = path.match(/\/collections\/([^/?#]+)/);
    if (m) {
      var handle;
      try { handle = decodeURIComponent(m[1]); } catch (e) { handle = m[1]; }
      return TITLES[handle] || handle.replace(/-/g, ' ');
    }
    m = path.match(/\/products\/([^/?#]+)/);
    if (m) {
      var ph;
      try { ph = decodeURIComponent(m[1]); } catch (e) { ph = m[1]; }
      return ph.replace(/-/g, ' ');
    }
    if (/\/search/.test(path)) return 'חיפוש';
    return '';
  }

  function fix() {
    document.querySelectorAll('a').forEach(function (a) {
      if (a.dataset.nadiA11y) return;
      if (named(a)) return;
      if (!a.getClientRects().length) return;      /* not painted: leave it */
      a.dataset.nadiA11y = '1';

      var href = a.getAttribute('href');
      if (!href || href === '#') { hide(a); return; }

      /* Already reachable by name from within the same card? */
      var card = a.closest('.t4s-product, .t4s-slideshow-item, .t4s-banner-item, .t4s-col-item, li');
      if (card) {
        var twin = [].slice.call(card.querySelectorAll('a')).some(function (x) {
          return x !== a && x.getAttribute('href') === href && (x.textContent || '').trim();
        });
        if (twin) { hide(a); return; }
      }

      var label = nameFromHref(href);
      if (!label) { hide(a); return; }
      a.setAttribute('aria-label', label);

      /* An unlabelled image inside a now-named link would be announced twice,
         once as the label and once as the file. Mark it decorative. */
      a.querySelectorAll('img:not([alt])').forEach(function (i) { i.setAttribute('alt', ''); });
    });
  }

  fix();

  /* Cards, slides and the brand strip all arrive or re-render late on this
     theme. Same answer the cart bar and the brand line reached. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; fix(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
